<script setup lang="ts">
import { ref } from 'vue'
import ApplicationItem from '@/components/Application/ApplicationItem.vue'
import { Utill } from '@/stores/Utill'
import { applicationList } from '@/stores/StaticText'
import { Data } from '@/stores/data'
import emitter from '@/stores/mitt'
import { ElMessage } from 'element-plus'
import { HTTP } from '@/network/http'
import XhDialogueView from '@/components/Application/XhDialogueView.vue'

let applicationData = applicationList

async function clickApplicationItemBtn(data: any) {
  // 检查是否已登录
  if (Utill.showLoginDialog()) {
    return
  }
  await Utill.checkRemaining()
  judgeApplicationItem(data)
}

function judgeApplicationItem(data: any) {
  console.log('Data.isTryOutAuthority.value', Data.isTryOutAuthority.value)
  if (Data.userInfo.value?.lv == 0 && Data.lastCanCountByUser.value == 0) {
    //邀请活动弹窗
    ElMessage({
      message: '您的使用次数已全部用完',
      type: 'warning',
      plain: true
    })
    Utill.showMemberOrActivityDialog()
    return
  }

  // 检查是否有试用权限
  // if (!Data.isTryOutAuthority.value) {
  //   let dialogData = {
  //     dialogType: 'experience',
  //     show: true,
  //     dialogTitle: '申请体验'
  //   }
  //   console.log(dialogData)
  //   emitter.emit('show-appDialog', dialogData)
  //   return
  // }
  // 检查应用状态
  if (data.status) {
    if (Data.userInfo.value?.lv == 0 && Data.lastCanCountByUser.value > 0) {
      //邀请活动弹窗
      if (data.resourceType == 'essayCorrection' || data.resourceType == 'mentalCalculation') {
        console.log('批改', data.resourceType)
        let dialogData = {
          show: true,
          tipDialogType: data.resourceType,
          tipDialogTitle: data.name,
        }
        emitter.emit('show-tipDialog', dialogData)
      } else {
        Utill.gotoNewLessonPage(data.resourceType)
      }
      return
    }
    // 如果应用状态为有效，检查会员时间
    console.log('会员时间', Data.isVipExpiration.value)
    if (!Data.isVipExpiration.value) {
      console.log('剩余次数', Data.userInfo.value?.remaining)
      if (Data.userInfo.value?.remaining == 0) {
        ElMessage({
          message: '今日您的使用次数已用完',
          type: 'warning',
          plain: true
        })
        return
      }
      if (data.resourceType == 'essayCorrection' || data.resourceType == 'mentalCalculation') {
        console.log('批改', data.resourceType)
        let dialogData = {
          show: true,
          tipDialogType: data.resourceType,
          tipDialogTitle: data.name
        }
        emitter.emit('show-tipDialog', dialogData)
      } else {
        Utill.gotoNewLessonPage(data.resourceType)
      }
    } else {
      ElMessage({
        message: '您的会员已到期',
        type: 'warning',
        plain: true
      })
    }
  } else {
    // 应用状态为无效（如正在研发）
    ElMessage({
      message: '正在研发中，敬请期待',
      type: 'warning',
      plain: true
    })
  }
}
function addApplicationBtn(data: any) {
  // Utill.gotoNewLessonPage(data.id)
}
function deleteApplicationBtn(data: any) {
  // Utill.gotoNewLessonPage(data.id)
}

const currentTab = ref(1)
const isClickTab = ref(false)
// function clickTab(id: number) {
//   isClickTab.value = true
//   currentTab.value = id
//   if (currentTab.value == 1) {
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: 'smooth'
//     })
//   }
//   // let currentId = 'tab-'+id
//   document.getElementById(`${id}`)?.scrollIntoView({
//     behavior: 'smooth'
//   })
//   setTimeout(() => {
//     console.log('111')
//     isClickTab.value = false
//   }, 3000)
// }

// onMounted(() => {
//   console.log(Data.isLogin.value)
//   const scrollable = document.querySelector('.application-list')
//   console.log(scrollable)
//   if (scrollable) {
//     scrollable.addEventListener('scroll', handleScroll)
//   }
// })
// onUnmounted(() => {
//   const scrollable = document.querySelector('.application-list')
//   console.log(scrollable)
//   if (scrollable) {
//     scrollable.removeEventListener('scroll', handleScroll)
//   }
// })
// function handleScroll(event: Event) {
//   if (isClickTab.value == true) {
//     return
//   }
//   console.log(event)
//   const target = event.target as HTMLElement
//   const scrollTop = target.scrollTop
//   console.log(scrollTop)
//   for (const item of applicationData) {
//     const element = document.getElementById(String(item.id))
//     console.log(element)
//     if (element) {
//       const rect = element.getBoundingClientRect()
//       console.log(item.id, rect)
//       if (rect.top >= scrollTop + 181 && rect.bottom <= scrollTop + target.clientHeight) {
//         currentTab.value = item.id
//         break
//       }
//     }
//   }
// }

function showLoginDialog() {
  let dialogData = {
    dialogType: 'login',
    show: true,
    dialogTitle: ''
  }
  console.log(dialogData)
  emitter.emit('show-appDialog', dialogData)
}

function submitMembershipForm(data: any) {
  console.log(data)
  // tipDialogTitle.value = '收到！'
  HTTP.submitMembership(data as any)
    .then((res) => {
      console.log(res)
      if (res.code == 200) {
        console.log(res)
        let dialogData = {
          show: true,
          tipDialogType: 'receive',
          tipDialogTitle: '收到！'
        }
        emitter.emit('show-tipDialog', dialogData)
      }
    })
    .catch((error) => {
      console.error('接口调用出错:', error)
    })
}

function showActivityDialog() {
  if (Utill.showLoginDialog()) {
    return
  }
  let dialogData = {
    show: true,
    activityDialogType: 'activity-main',
    activityDialogTitle: "邀请活动"
  }
  console.log(dialogData)
  emitter.emit('show-actDialog', dialogData)
}
</script>

<template>
  <div class="application-ctr">
    <div v-if="Data.isActivityOpen.value">
      <div style="" v-show="!Data.isLogin.value">
        <el-carousel height="238px" :interval="3000" :autoplay="true">
          <el-carousel-item>
            <div class="login-content">
              <div class="content-title"><span class="title-left">小鸿助教，</span>轻松备课</div>
              <p class="content-tip">用AI重塑教学流程</p>
              <el-button @click="showLoginDialog" class="app-login-btn">免费体验</el-button>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="activity-ctr" @click="showLoginDialog">
              <img class="act-content-img" src="@/assets/activity/1031/act-bg-content.png" alt="">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="act-banner-ctr" v-show="Data.isLogin.value" @click="showActivityDialog">
        <img class="banner-content-img" src="@/assets/activity/1031/banner-bg-content.png" alt="">
      </div>
    </div>
    <div v-if="!Data.isActivityOpen.value">
      <div style="" v-show="!Data.isLogin.value">
        <el-carousel height="238px" :interval="3000" :autoplay="true" v-show="Data.lv.value != '1'">
          <el-carousel-item>
            <div class="login-content">
              <div class="content-title"><span class="title-left">小鸿助教，</span>轻松备课</div>
              <p class="content-tip">用AI重塑教学流程</p>
              <el-button @click="showLoginDialog" class="app-login-btn">免费体验</el-button>
            </div>
          </el-carousel-item>
          <!--          终身会员不显示日常活动-->
          <!-- <el-carousel-item>
            <div class="activity-ctr" @click="showLoginDialog" :class="!Data.isActivityOpen.value ? 'common-act-ctr' : ''">
              <img class="act-content-img" src="https://static.yipigai.cn/public/activity/common-act-bg-content.png"
                alt="">
            </div>
          </el-carousel-item> -->
        </el-carousel>
        <div class="login-content" v-show="Data.lv.value == '1'">
          <div class="content-title"><span class="title-left">小鸿助教，</span>轻松备课</div>
          <p class="content-tip">用AI重塑教学流程</p>
          <el-button @click="showLoginDialog" class="app-login-btn">免费体验</el-button>
        </div>
      </div>
      <!--          终身会员不显示日常活动-->
      <!-- <div class="act-banner-ctr" v-show="Data.isLogin.value && Data.lv.value != '1'" @click="showActivityDialog"
        :class="!Data.isActivityOpen.value ? 'common-act-banner-ctr' : ''">
        <img class="banner-content-img" src="https://static.yipigai.cn/public/activity/common-banner-content.png"
          alt="">
      </div> -->
    </div>


    <!--    <div class="application-title" v-if="Data.isLogin.value">-->
    <!--      <div-->
    <!--        v-for="(tab, index) in applicationData"-->
    <!--        :key="index"-->
    <!--        class="title-item"-->
    <!--        :class="{ [tab.activeClass]: currentTab === tab.id }"-->
    <!--        @click="clickTab(tab.id)"-->
    <!--      >-->
    <!--        <img :class="['title-icon', tab.iconClass]" :src="tab.icon" alt="" />-->
    <!--        <div class="title-item-name">{{ tab.name }}</div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="application-list">
      <div class='xhQA-view'>
        <XhDialogueView :isHaveTitle=false :isApplicationLink="true">
        </XhDialogueView>
      </div>
      <div class="list-ctr" v-for="applicationItems in applicationData" :key="applicationItems.id"
        :class="applicationItems.id == 1 ? 'long-app-ctr' : 'short-app-ctr'" :id="applicationItems.id + ''">
        <div class="list-title">
          <div class="list-title-item">{{ applicationItems.name }}</div>

          <div class="title-bg-img"></div>
        </div>
        <div class="list-item-ctr" :class="applicationItems.id == 1 ? 'long-item-ctr' : 'short-item-ctr'">
          <ApplicationItem v-for="item in applicationItems.applicationItem" :key="item.id" :itemData="item"
            :showGoBtn="false" :showDeleteBtn="false" :showAddBtn="false"
            @clickApplicationItemBtn="clickApplicationItemBtn"></ApplicationItem>
        </div>
      </div>
      <div class="footer">世纪天鸿教育科技股份有限公司 鲁ICP备10021819号-21</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.application-ctr {
  //background: linear-gradient(180deg, #F3F3F6 0%, #EAEDF6 100%);
  background: url('@/assets/right-bg.jpg') no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}

.application-title {
  padding-top: 47px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  :deep(.el-radio-button) {
    height: 38px;
    margin-right: 7px;
    margin-top: 29px;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0px;
    --el-radio-button-checked-bg-color: rgba(72, 92, 236, 0.2);
    --el-radio-button-checked-text-color: #485cec;
    --el-radio-button-checked-border-color: transparent;
    --el-radio-button-disabled-checked-fill: var(--el-border-color-extra-light);

    .el-radio-button__inner:hover {
      color: #485cec !important;
    }

    .el-radio-button__inner {
      border-radius: 12px !important;
    }
  }
}

.title-name {
  font-size: 18px;
  font-weight: bold;
  line-height: 16px;
  letter-spacing: 0px;
  color: #040a39;
}

.application-list {
  /*padding-left: 24px;
  padding-right: 18px;*/
  flex: 1;
  //overflow-y: scroll;
  width: 100%;
  position: relative;
}

.list-ctr {
  margin-left: 24px;
  margin-right: 18px;
}

.long-app-ctr {
  margin-top: 52px;
}

.list-title {
  font-size: 18px;
  font-weight: bold;
  line-height: 28px;
  letter-spacing: 0px;
  font-feature-settings: 'kern' on;
  color: #040a39;
  position: relative;
}

.list-title-item {
  position: relative;
  z-index: 100;
}

.title-bg-img {
  position: absolute;
  left: 7px;
  top: 8px;
  width: 59px;
  height: 15px;
  transform: rotate(-16.75deg);
  opacity: 1;
  background: #b3c3ff;
}

.title-item {
  height: 38px;
  width: 139px;
  background: #ffffff;
  border-radius: 8px;
  position: relative;
  margin-right: 29px;
  color: #040a39;
}

.title-item:hover {
  cursor: pointer;
  transform: translateY(-2px);
  transition: 0.2s;
  backdrop-filter: blur(4px);
  box-shadow: 0px 4px 10px 0px rgba(158, 172, 229, 0.3);
}

.tab1-selected {
  background: #f696ab;
  color: #ffffff;
}

.tab2-selected {
  background: #a3b9f7;
  color: #ffffff;
}

.tab3-selected {
  background: #fac965;
  color: #ffffff;
}

.title-icon {
  width: 40px;
  height: 40px;
  position: absolute;
  top: -11px;
  left: 8px;
}

.hw-icon {
  width: 34px;
  height: auto;
  position: absolute;
  top: -10px;
  left: 13px;
}

.work-icon {
  width: 43px;
  height: auto;
  position: absolute;
  top: -7px;
  left: 13px;
}

.title-item-name {
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0px;
  position: absolute;
  top: 7px;
  right: 16px;
}

.list-item-ctr {
  padding-top: 25px;
  padding-left: 16px;
  padding-bottom: 18px;
  margin-top: 6px;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  /*gap: 16px;*/
  /*min-width: 718px;*/

}

.long-item-ctr {
  //min-width: 1294px;
  padding-right: 16px;
}

.short-item-ctr {
  padding-right: 0;
  min-width: 718px;
  //width: 91%;
}

//@media only screen and (max-width: 1440px) {
//  .long-item-ctr {
//    width: 1294px;
//    padding-right: 16px;
//  }
//  .short-item-ctr {
//    padding-right: 0;
//    width: 1294px;
//  }
//
//}
//
//@media only screen and (max-width: 1180px) {
//  .long-item-ctr {
//    width: 1200px;
//    padding-right: 16px;
//  }
//  .short-item-ctr {
//    padding-right: 0;
//    width: 700px;
//  }
//
//}

//.list-item-ctr:hover {
//  background: rgba(255, 255, 255, 0.2);
//  backdrop-filter: blur(4px);
//  box-shadow:
//    inset 0 4px 8px 0 #ffffff,
//    inset 0 0 4px 0 #ffffff;
//}
//.ctr-selected {
//  background: rgba(255, 255, 255, 0.2);
//  backdrop-filter: blur(4px);
//  box-shadow:
//    inset 0 4px 8px 0 #ffffff,
//    inset 0 0 4px 0 #ffffff;
//}
.login-content {
  height: 238px;
  background: url('@/assets/experience-bg.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  display: -webkit-box;
  /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */
  display: -moz-box;
  /* Firefox 17- */
  display: -webkit-flex;
  /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */
  display: -moz-flex;
  /* Firefox 18+ */
  display: -ms-flexbox;
  /* IE 10 */
  display: flex;
  /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */
  flex-direction: column;
  align-items: center;
  padding-top: 47px;
  flex-shrink: 0;
}

.activity-ctr {
  height: 238px;
  background: url('@/assets/activity/1031/act-bg-color.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.common-act-ctr {
  background: url('https://static.yipigai.cn/public/activity/common-act-bg-color.png')no-repeat;
  background-size: 100% 100%;
}

.act-content-img {
  width: 100%;
  height: auto;
  max-width: 1343px;

}

.act-content-btn {
  position: absolute;
  width: 31px;
  height: 31px;
  top: 36px;
  right: 353px;
}

.act-banner-ctr {
  height: auto;
  background: url('@/assets/activity/1031/banner-bg-color.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.common-act-banner-ctr {
  background: url('https://static.yipigai.cn/public/activity/common-banner-bg.png') no-repeat;
  background-size: 100% 100%;
}

.banner-content {
  width: 100%;
  margin: auto;
  position: relative;
}

.banner-content-img {
  width: 100%;
  height: auto;
  max-width: 1343px;
}

.content-title {
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  color: #040a39;
  margin-bottom: 19px;
}

.title-left {
  color: #485cec;
}

.content-tip {
  font-size: 16px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0px;
  color: #718096;
  margin-bottom: 23px;
}

.app-login-btn {
  background: linear-gradient(90deg, #fc5f94 0%, #5a9afa 59%, #485cec 98%);
  background-size: 400% 400%;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0px;
  color: #ffffff;
  width: 165px;
  height: 52px;
  border-radius: 39px;
  //animation: slide 5s ease infinite;
  animation: slide 3s ease infinite;
  border: none;
  margin-bottom: 36px;
}

@keyframes slide {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.xhQA-view {
  width: 775px;
  height: 48px;
  margin-top: 16px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>
<!--<style>
.wait-message {
  &#45;&#45;el-message-text-color: #040a39 !important;
}
.el-message .el-message-icon&#45;&#45;warning {
  color: #485cec;
}
</style>-->
<style>
.el-carousel__indicators--horizontal {
  height: 15px;
}

.el-carousel__indicator--horizontal {
  padding: 3px 10px 3px 0;
}

.el-carousel__button {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: rgba(22, 93, 255);
  opacity: 0.2;
}
</style>
